import { DWSStartedController } from './started.controller';
import template from './started.html';

export const dwsStartedComponent = {
  name: 'dwsStartedComponent',
  restrict: 'E',
  template,
  controller: DWSStartedController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<',
  },
};
